import * as Types from './actionTypes';

export const init = (summary, quotes) => ({
  type: Types.INIT,
  payload: {
    summary,
    quotes,
  },
});

export const reset = () => ({
  type: Types.RESET,
});

export const save = (shipperId, itineraryId) => ({
  type: Types.SAVE,
  payload: {
    shipperId,
    itineraryId,
  },
});

export const call = (shipperId, itineraryId) => ({
  type: Types.CALL,
  payload: {
    shipperId,
    itineraryId,
  },
});

export const markAsPaid = (id, token, cardLastDigits, method, expiryDate) => ({
  type: Types.MARK_AS_PAID,
  payload: {
    id,
    token,
    cardLastDigits,
    method,
    expiryDate,
  },
});
